import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/validators/page.tsx");
